module.exports = __webpack_public_path__ + "img/icone-tree.ebc40b26.svg";